
export default {
  props: {
    width: {
      type: String,
      default: '232'
    },
    item: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: '1'
    }
  }
}
